import { FC, useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { IConvert } from '../../../../models/evaluation.model';
import { Descriptions } from 'antd';
import { useSnackbar } from 'notistack';
import Button from '../../../Button';
import useAuth from '../../../../hooks/useAuth';

interface IProps {
  convert: IConvert | null;
  onSubmit: Function;
  id: number;
  name: string;
}

const ProgramConvertTableEditor: FC<IProps> = ({ convert, onSubmit, id, name }) => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');

  const inputInput = useRef<any>();
  const outputInput = useRef<any>();

  useEffect(() => {
    if (convert) {
      setInput(convert.evaluationInput);
      setOutput(String(convert.conversionScore));
    }
  }, [convert]);

  const onSave = async () => {
    if (!inputInput) {
      return enqueueSnackbar(t('program.convert.message3'), {
        variant: 'info'
      });
    }
    if (!outputInput) {
      return enqueueSnackbar(t('program.convert.message4'), {
        variant: 'info'
      });
    }

    onSubmit({
      evaluationInput: input,
      conversionScore: output
    })
  }

  return (
    <div className='comm-table__area rowType mt-0'>
      <Descriptions
        bordered
        column={1}
        size="small"
      >
        <Descriptions.Item label="Input">
          <input
            type="text"
            className="form-control input-text"
            value={input}
            onChange={e => setInput(e.target.value)}
            ref={inputInput}
          />
        </Descriptions.Item>
        <Descriptions.Item label="Output">
          <input
            type="number"
            className="form-control input-text"
            value={output}
            onChange={e => setOutput(e.target.value)}
            ref={outputInput}
          />
        </Descriptions.Item>
      </Descriptions>
      <div className="comm-bx__space">
        <div className="comm-btn__area right">
          <Button
            className="btn-basic pink"
            onClick={onSave}
            text={t('common.button.save')}
            writeAuthYn={writeAuthYn}
          />
          <Button
            className="btn-basic gray"
            onClick={() => history.push(`/program/convert/${id}/table?name=${name}`)}
            text={t('common.button.cancel')}
          />
        </div>
      </div>
    </div>
  )
}

export default ProgramConvertTableEditor;
